import Vue from "vue";
import Router from "vue-router";
import list from "@/view/list";
import complaint from "@/view/complaint";
import info from "@/view/info";
import feedback from "@/view/feedback";
import agreement from "@/view/agreement";
import cancellation from "@/view/cancellation";
import service from "@/view/service";
import userservice from "@/view/userservice";
import productDetails from "@/view/productDetails";
import resign from "@/view/resign";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      redirect: "/agreement"
    },
    {
      path: "/list", //列表
      name: "list",
      component: list
    },
    {
      path: "/complaint",
      name: "complaint",
      component: complaint
    },
    {
      path: "/info", //信息
      name: "info",
      component: info
    },
    {
      path: "/feedback", //反馈
      name: "feedback",
      component: feedback
    },
    {
      path: "/agreement", //橙鹿隐私政策
      name: "agreement",
      component: agreement
    },
    {
      path: "/service", //橙鹿用户增值服务协议
      name: "service",
      component: service
    },
    {
      path: "/userservice", //橙鹿用户服务协议
      name: "userservice",
      component: userservice
    },
    {
      path: "/cancellation", //合同作废声明
      name: "cancellation",
      component: cancellation
    },
    {
      path: "/productDetails", //商品详情
      name: "productDetails",
      component: productDetails
    },
    {
      path: "/resign", //重签成功
      name: "resign",
      component: resign
    },
    {
      path: "/goBack",//橙鹿小程序支付跳转页面
      name: "goBack",
      component: () => import("../view/goBack.vue") //返回页面
    },
    {
      path: "/pay",//橙鹿支付异常处理页面
      name: "goBack",
      component: () => import("../view/pay.vue")
    },
    {
      path: "/goldservice",//橙鹿教育科技“金鹿”系统平台服务协议
      name: "goldservice",
      component: () => import("../view/goldservice.vue")
    },
    {
      path: "/xlbvip",//橙鹿付费会员协议
      name: "xlbvip",
      component: () => import("../view/xlbvip.vue")
    },
    {
      path: "/orderDetail",//订单核对详情页面
      name: "orderDetail",
      component: () => import("../view/orderDetail.vue")
    },
    {
      path: "/copyrightNotice",//橙鹿版权声明
      name: "copyrightNotice",
      component: () => import("../view/copyrightNotice.vue")
    },
    {
      path: "/creatorCenter",//创作者协议
      name: "creatorCenter",
      component: () => import("../view/creatorCenter.vue")
    },
    {
      path: "/app_privacyClause",//橙鹿app-隐私政策
      name: "app_privacyClause",
      component: () => import("../view/app_privacyClause.vue")
    },
    {
      path: "/app_agreement",//橙鹿app-用户协议
      name: "app_agreement",
      component: () => import("../view/app_agreement.vue")
    },
    {
      path: "/supplier_agreement",//金鹿供应商使用协议
      name: "supplier_agreement",
      component: () => import("../view/supplier_agreement.vue")
    },
    {
      path: "/cyan_privacy",//云麓青课隐私保护指引
      name: "cyan_privacy",
      component: () => import("../view/cyan_privacy.vue")
    },
    {
      path: "/cyan_user",//青鹿小程序用户服务协议
      name: "cyan_user",
      component: () => import("../view/cyan_user.vue")
    },
    {
      path: "/zbdPrivacy",//学历包智播达隐私政策
      name: "zbdPrivacy",
      component: () => import("../view/zbdPrivacy.vue")
    },
    {
      path: "/zbdAuth",//学历包智播达授权书
      name: "zbdAuth",
      component: () => import("../view/zbdAuth.vue")
    },
    {
      path: "/goldPlatformServiceAgreement",//橙鹿教育科技“金鹿”系统平台服务协议
      name: "goldPlatformServiceAgreement",
      component: () => import("../view/goldPlatformServiceAgreement.vue")
    },
    {
      path: "/rhAgreement",//红鹿运营助手用户服务协议
      name: "rhAgreement",
      component: () => import("../view/rhAgreement.vue")
    },
    {
      path: "/rhPrivacyClause",//红鹿运营助手隐私政策
      name: "rhPrivacyClause",
      component: () => import("../view/rhPrivacyClause.vue")
    },
    {
      path: "/paperDownload",//橙鹿 百度和抖音小程序论文下载页
      name: "paperDownload",
      component: () => import("../view/paperDownload.vue")
    },
    {
      path: "/baichuanPrivacy",//橙鹿百川隐私政策
      name: "baichuanPrivacy",
      component: () => import("../view/baichuanPrivacy.vue")
    },
    {
      path: "/baichuanAuth",//橙鹿百川授权书
      name: "baichuanAuth",
      component: () => import("../view/baichuanAuth.vue")
    },
    {
      path: "/zhijiaobaoPrivacy",//职教宝隐私政策
      name: "zhijiaobaoPrivacy",
      component: () => import("../view/zhijiaobaoPrivacy.vue")
    },
    {
      path: "/zhijiaobaoAuth",//职教宝授权书
      name: "zhijiaobaoAuth",
      component: () => import("../view/zhijiaobaoAuth.vue")
    },
    {
      path: "/guangliangPrivacy",//广量隐私政策
      name: "guangliangPrivacy",
      component: () => import("../view/guangliangPrivacy.vue")
    },
    {
      path: "/guangliangAuth",//广量授权书
      name: "guangliangAuth",
      component: () => import("../view/guangliangAuth.vue")
    },
    {
      path: "/linghangPrivacy",//领航隐私政策
      name: "linghangPrivacy",
      component: () => import("../view/linghangPrivacy.vue")
    },
    {
      path: "/linghangAuth",//领航授权书
      name: "linghangAuth",
      component: () => import("../view/linghangAuth.vue")
    },
    {
      path: "/chuangyaPrivacy",//创雅隐私政策
      name: "chuangyaPrivacy",
      component: () => import("../view/chuangyaPrivacy.vue")
    },
    {
      path: "/chuangyaAuth",//创雅授权书
      name: "chuangyaAuth",
      component: () => import("../view/chuangyaAuth.vue")
    },
    {
      path: '/xlbQueryIndex',
      name: 'xlbQueryIndex',
      component: () => import("../view/xlbQueryIndex.vue")
    },
    {
      path: '/xlbLzx',
      name: 'xlbLzx',
      component: () => import("../view/xlbLzx.vue")
    },
    {
      path: '/sdkPrivacy', //sdk隐私政策
      name: 'sdkPrivacy',
      component: () => import("../view/sdkPrivacy.vue")
    },
    {
      path: '/appDown', //app下载
      name: 'appDown',
      component: () => import("../view/appDown.vue")
    },
    {
      path: '/gbLogin', //高报中转登录
      name: 'gbLogin',
      component: () => import("../view/gbLogin.vue")
    },
    {
      path: "/xiangyunPrivacy",//翔云学府隐私政策
      name: "xiangyunPrivacy",
      component: () => import("../view/xiangyunPrivacy.vue")
    },
    {
      path: "/xiangyunAuth",//翔云学府授权书
      name: "xiangyunAuth",
      component: () => import("../view/xiangyunAuth.vue")
    },
    {
      path: "/baokaozixunPrivacy",//学历宝报考咨询隐私政策
      name: "baokaozixunPrivacy",
      component: () => import("../view/baokaozixunPrivacy.vue")
    },
    {
      path: "/baokaozixunAuth",//学历宝报考咨询授权书
      name: "baokaozixunAuth",
      component: () => import("../view/baokaozixunAuth.vue")
    },
    {
      path: "/ruiboPrivacy",//睿博学途隐私政策
      name: "ruiboPrivacy",
      component: () => import("../view/ruiboPrivacy.vue")
    },
    {
      path: "/ruiboAuth",//睿博学途授权书
      name: "ruiboAuth",
      component: () => import("../view/ruiboAuth.vue")
    },
    {
      path: "/jiazhouPrivacy",//嘉舟学园隐私政策
      name: "jiazhouPrivacy",
      component: () => import("../view/jiazhouPrivacy.vue")
    },
    {
      path: "/jiazhouAuth",//嘉舟学园授权书
      name: "jiazhouAuth",
      component: () => import("../view/jiazhouAuth.vue")
    },
    {
      path: "/qiweiAdd",//企业微信添加好友
      name: "qiweiAdd",
      component: () => import("../view/qiweiAdd.vue")
    },
     {
      path: "/oem_agreement",//oem用户协议
      name: "oem_agreement",
      component: () => import("../view/oem_agreement.vue")
    },
     {
      path: "/oem_privacyClause",//oem隐私协议
      name: "oem_privacyClause",
      component: () => import("../view/oem_privacyClause.vue")
    },
    {
      path: "/oem_design_privacyClause",//oem定制通用用户协议
      name: "oem_design_privacyClause",
      component: () => import("../view/oem_design_privacyClause.vue")
    },
     {
      path: "/oem_design_privacyPolicy",//oem定制通用隐私协议
      name: "oem_design_privacyPolicy",
      component: () => import("../view/oem_design_privacyPolicy.vue")
    },
    {
      path: "/aiQuestionFileSelect",//AI导题文件选择
      name: "aiQuestionFileSelect",
      component: () => import("../view/aiQuestionFileSelect.vue")
    },
    {
      path: "/aiMaterialFileSelect",//AI资料文件选择
      name: "aiMaterialFileSelect",
      component: () => import("../view/aiMaterialFileSelect.vue")
    },
    {
      path: "/sharePost",//分享干货-发布页（Figma 1280:5361）
      name: "sharePost",
      component: () => import("../view/sharePost.vue")
    },
    {
      path: "/faceVerifyResult",// 人脸识别结果页
      name: "faceVerifyResult",
      component: () => import("../view/faceVerifyResult.vue")
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js